import images from "../../../assets/images";
import { useTranslation } from "react-i18next";
const Section3: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="aboutAman__shakingHand__section mt-5" id={"aboutAman"}>
      <div className="d-flex">
        <div className="aboutAman__shakingHand__img col-lg-4"></div>
        <div className="aboutAman__shakingHand__content col-lg-7">
          <h3 className="font bold text-white mb-4">{t("About aman")}</h3>
          <h2 className="font bold text-white mb-5">
            {t("We aim to be the leader in microfinance")}
          </h2>
          <p className="font light text-white fs-5">
            {t(
              "Aman Microfinance, one of Aman Holding's companies, specializes in providing financing solutions that support business owners and help them grow their businesses."
            )}
          </p>
          <p className="font light text-white fs-5 mb-5">
            {t(
              "Through diverse and flexible financing services, it helps business owners meet their operating and expansion needs, supporting the growth and sustainability of their businesses."
            )}
          </p>
          <a
            target={"_blank"}
            href="https://rayacorp.com/"
            className="btn font bold rounded-pill text-white"
          >
            {t("More about Aman")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Section3;
